import { render } from "./CategoryElement.vue?vue&type=template&id=8e8e6150"
import script from "./CategoryElement.vue?vue&type=script&lang=js"
export * from "./CategoryElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__